<p-dialog
  header="Assign Organization"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [style]="{ width: '50vw' }"
  (onHide)="onCloseDialog()">

  <p>Assign these {{ devices.length }} devices to an organization.</p>

  <p-table
    [value]="devices"
    responsiveLayout="scroll"
    styleClass="p-datatable-sm p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Serial</th>
        <th>Org</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-device>
      <tr>
        <td>{{ device.name || 'No Name Assigned' }}</td>
        <td>{{ device.serial || 'No Serial Assigned' }}</td>
        <td>{{ device.org?.name || 'No Org Assigned' }}</td>
      </tr>
    </ng-template>
  </p-table>

  <div class="p-fluid p-mt-4">
    <div class="p-field">
      <label for="orgAssignField">Organization</label>
      <p-dropdown
        id="orgAssignField"
        [options]="orgs"
        [(ngModel)]="orgSelected"
        placeholder="Select an Organization"
        optionLabel="name"
        [showClear]="true"
        [filter]="true"
        filterBy="name"
        filterPlaceholder="Search orgs"
        [resetFilterOnHide]="true"
        appendTo="body">
      </p-dropdown>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      *ngIf="isVam"
      icon="pi pi-times"
      (onClick)="openUnassignConfirm()"
      [disabled]="!!orgSelected || !canUnassign"
      label="Unassign"
      styleClass="p-button">
    </p-button>
    <p-button
      icon="pi pi-check"
      (onClick)="assign()"
      [disabled]="!orgSelected"
      label="Assign"
      styleClass="p-button-warning">
    </p-button>
  </ng-template>
</p-dialog>

<p-dialog
  header="Are you sure?"
  [visible]="confirmUnassignModalOpen"
  (visibleChange)="confirmUnassignModalOpen = $event"
  [modal]="true"
  [style]="{ width: '35vw' }">

  <p>This will remove the organization from the selected device(s).</p>
  <p>It will also clear the assigned Device Profile and Voice Profile.</p>

  <ng-template pTemplate="footer">
    <p-button
      label="Cancel"
      styleClass="p-button-text"
      (onClick)="confirmUnassignModalOpen = false">
    </p-button>

    <p-button
      label="Unassign"
      styleClass="p-button-danger"
      (onClick)="confirmUnassign()">
    </p-button>
  </ng-template>
</p-dialog>
